export enum PortalPaths {
  Home = '/',
  Dashboard = '/dashboard',
  Messages = '/messages',
  Account = '/account',
  PendingFeedbacks = '/pending-feedbacks',
}
